import {styled} from "@mui/material/styles"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const ModalContainer = styled("div")`
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    color: ${({theme}) => theme.uxfabric.text.primary};
    padding: 1.375rem 1.5rem;
    width: 90%;
    min-height: 16.625rem;

    @media (min-width: ${breakpoints.values.md}px) {
        min-height: 12.5rem;
        width: 80%;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        width: 55%;
    }
`

export const ButtonContainer = styled("div")`
    div:first-of-type {
        margin-bottom: 0.75rem;
    }

    @media (min-width: ${breakpoints.values.md}px) {
        float: right;
        width: 90%;
        display: flex;
        margin-top: 0.5rem;

        div:first-of-type {
            margin-right: 1rem;
            margin-bottom: 0;
        }
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        height: 2.25rem;
        width: 80%;
    }
`

export const CTAContainer = styled("div")`
    height: 2.75rem;
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY};
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    width: 100%;
`
